import { useCallback, useEffect } from "react";
import { Socket } from "socket.io-client";

export type SocketTask = {
  id: string;
  name: string;
  events: Partial<Record<string, (data: any) => void>>;
  cancelEventName: string;
};

export const useSocketTasks = (
  socket: Socket | undefined,
  tasks: SocketTask[],
  onChangeJob?: (jobId: string, status: string) => void
) => {

  const setupListeners = useCallback(() => {
  if (!socket) return;

  tasks.forEach((task) => {
    Object.keys(task.events).forEach((eventKey) => {
      const fullEventName = `${eventKey}_${task.id}`;
      socket.off(fullEventName);
      //@ts-ignore
      socket.on(fullEventName, task.events[eventKey]);
    });
  });

  // Checa status de jobs ativos só uma vez
  tasks.forEach((task) => {
    socket.emit("check_job_status", `${task.name}_${task.id}`);
  });
}, [socket, tasks]);

  useEffect(() => {
    if (!socket) return;

    // Cria listeners na primeira vez
    if (socket.connected) {
      setupListeners();
    }

    // Recria listeners ao reconectar
    socket.off("connect", setupListeners);
    socket.on("connect", setupListeners);

    // Ouvir resposta de status
    socket.on("job_status_response", (data: { jobId: string; status: string }) => {
      if (onChangeJob) {
        onChangeJob(data.jobId, data.status);
      }
    });

    return () => {
      socket.off("connect", setupListeners);
      socket.off("job_status_response");

      tasks.forEach((task) => {
        Object.keys(task.events).forEach((eventKey) => {
          const fullEventName = `${eventKey}_${task.id}`;
          socket.off(fullEventName);
        });
      });
    };
  }, [socket, tasks, onChangeJob, setupListeners]);
};

// Função auxiliar para cancelar um job específico
export const cancelTask = (
  socket: Socket | undefined,
  taskId: string,
  cancelEventName: string
) => {
  if (!socket?.connected) return;
  socket.emit(cancelEventName, taskId);
};
